import * as numeral from 'numeral';
export class NumberDisplayValueConverter {
    toView(value) {
        if (value === null || value === undefined || value === "") {
            return value;
        }

        if (typeof value == "number") {
            return value.toLocaleString();
        } else {
            return value;
        }
    }
    fromView(value) {
        if (value === null || value === undefined || value === "") {
            return undefined;
        }
        return numeral(value).value();  
    }
}